<template>
    <div v-if="vatOptions.length > 0">
        <USelect
            v-model="selectedValueVatId"
            :items="vatOptions"
            class="w-full z-10"
            size="sm"
            value-key="id"
            :ui="{
                base: 'h-[26px]',
                content: 'z-10'
            }"
        >
            <template #default>
                <div v-if="selectedVatOption" class="flex items-center justify-between w-full">
                    <div class="flex gap-2">
                        <span>{{ selectedVatOption.code }}</span>
                        -
                        <span>{{ formatPercentage(selectedVatOption.displayedRate) }}</span>
                    </div>

                    <span v-if="selectedVatOption.id !== systemVatOption?.id" class="line-through text-gray-400">{{ systemVatOption?.code }}</span>
                </div>
            </template>

            <template #item="{ item }">
                <div class="grid grid-cols-4 gap-x-2" :class="{ 'text-primary': item.id === selectedVatOption?.id }">
                    <span class="col-span-1 shrink-0 font-semibold">{{ item.code }} ({{ formatPercentage(item.displayedRate) }})</span>
                    <div class="col-span-3">
                        <span v-if="item.specificationKey" class="shrink-0">{{ $t('vat-codes.' + item.specificationKey) }}:</span>
                        <span>{{ $t('vat-codes.' + item.code) }}</span>
                    </div>
                </div>
            </template>
        </USelect>
    </div>
</template>

<script setup lang="ts">
import { GridApi, RowNode } from 'ag-grid-community'
import { computed } from 'vue'
import { CsvDataRow } from '@/incoming-balance/types/CsvDataRow.type'
import useTrialBalance from '@/incoming-balance/tribal.composable'
import { useVatService } from '@/vat/vat.service'
import { ColumnMapping } from '@/incoming-balance/types/ColumnMapping.type'
import { VatOption } from '@/vat/types/VatOptions'
import { formatPercentage } from '@/services/formatter.service'
import {CsvData} from '@/incoming-balance/types/CsvData.type'

const props = defineProps({
    params: {
        type: Object as () => {
            data: CsvDataRow
            api: GridApi
            node: RowNode
            value: string | undefined
            context: {
                isCustomer: boolean
                columnMapping: ColumnMapping,
                csvData: CsvData
            }
        },
        required: true
    }
})

const csvRow = computed<CsvDataRow>(() => props.params.data)

const { getSystemVatOption } = useTrialBalance()
const { vatOptions } = useVatService()

const systemVatOption = computed(() => getSystemVatOption(csvRow.value))

// Messy shit
const selectedValueVatId = computed<number | undefined>({
    get() {
        const cellValue = props.params.value

        // initial state - code from imported file
        if (typeof cellValue === 'string') {
            const foundByCode = vatOptions.value.find(opt =>
                opt.code?.toString().toLowerCase() === cellValue.toLowerCase()
            )
            if (foundByCode) return foundByCode.id
        }

        // updated state - id
        if (typeof cellValue === 'number') {
            return cellValue
        }

        return systemVatOption.value?.id ?? 1
    },
    set(id) {
        if (id === undefined || id === null) return

        // changes the value from "string" to "number"
        props.params.node?.setDataValue('vat', id)

        csvRow.value[props.params?.context.columnMapping['vat']] = id as number
    }
})

const selectedVatOption = computed<VatOption | undefined>(() =>
    vatOptions.value.find(option => option.id?.toString() === selectedValueVatId.value?.toString())
)

</script>

<style scoped>
</style>
